import {
  sortByHotDeal,
  sortByPrice,
  sortByPriceDesc
} from '../../other/services/sorting'

const random = () => {
  return Math.floor((Math.random() * 100000 + 1))
}

export default {
  data () {
    return {
      activeRequests: [],
      selectedResultsPerPage: Number.MAX_SAFE_INTEGER,
      selectedSortMethod: sortByPrice,
      resultsPerPage: [
        { text: 'toate rezultatele', value: Number.MAX_SAFE_INTEGER },
        { text: '25 rezultate/pagina', value: 25 },
        { text: '50 rezultate/pagina', value: 50 },
        { text: '100 rezultate/pagina', value: 100 }
      ],
      sortMethods: [
        { text: 'Sorteaza rezultatele', value: null },
        // { text: $gettext('Best Deal'), value: sortByHotDeal },
        { text: 'Pret de la mic la mare', value: sortByPrice },
        { text: 'Pret de la mare la mic', value: sortByPriceDesc }
      ],
      roomKey: 'room' + random()
    }
  },
  computed: {
    sortDropdownClass () {
      return { 'best-deal': this.selectedSortMethod === sortByHotDeal }
    }
  },
  methods: {
    genRoomKey (index) {
      return this.roomKey + '/' + index
    },
    onSubmit () {
      this.$emit('search', this.selectedParams)
    },
    resetList (toBeReset) {
      const arrayOfLists = Array.isArray(toBeReset) ? toBeReset : [toBeReset]
      arrayOfLists.forEach(el => {
        this[el + 'List'] = []
      })
    },
    onRoomAdd () {
      this.selectedParams.rooms.push({ adults: 2, ages: [] })
      this.roomKey = 'room' + random()
    },
    onRoomDelete (index) {
      this.selectedParams.rooms.splice(index, 1)
      this.roomKey = 'room' + random()
    },
    valueExistsInList (listName, value) {
      const list = this[listName + 'List']
      const index = list.findIndex(el => (el === value) || (el.id && el.id === value))
      return index >= 0
    },
    addRequest (reqType) {
      this.activeRequests.push(reqType)
    },
    removeRequest (reqType) {
      const index = this.activeRequests.indexOf(reqType)
      if (index >= 0) this.activeRequests.splice(index, 1)
    }
  }
}
